<template>
  <div
    class="flex flex-col items-center gap-20 -mt-62 px-0 pt-28 pb-16 bg-[url('https://images.rafflebox.ca/RaffleboxLogos/WebsiteAssets/social-proof-bg-rev.svg')] bg-cover bg-top bg-no-repeat"
  >
    <h2 class="flex flex-col items-center gap-2 text-center leading-tight text-white">
      <span class="text-5xl sm:text-6xl">{{ t('HomeLogoCarousel.heading1') }}</span>
      <span class="text-4xl sm:text-5xl">{{ t('HomeLogoCarousel.heading2') }}</span>
    </h2>
    <div class="w-full max-w-screen">
      <Carousel
        :value="slides"
        :num-visible="4"
        :num-scroll="4"
        :circular="true"
        :autoplay-interval="5000"
        :responsive-options="responsiveOptions"
        :pt="{
          contentContainer: { class: 'gap-4 sm:gap-6 md:gap-8 lg:gap-10 px-4 md:px-8 lg:px-12' },
          content: { class: 'flex justify-between w-full' },
          pcPrevButton: {
            root: { class: 'group' },
            icon: { class: 'text-white group-hover:text-zinc-700 transition-colors' },
          },
          pcNextButton: {
            root: { class: 'group' },
            icon: { class: 'text-white group-hover:text-zinc-700 transition-colors' },
          },
          indicatorList: { class: 'hidden sm:flex gap-6' },
          indicator: { class: 'data-[p-active=true]:bg-white rounded-full' },
          indicatorButton: {
            class: 'w-3 h-3 rounded-full border-1 border-white bg-transparent hover:bg-white transition-colors',
          },
        }"
      >
        <template #item="slotProps">
          <a
            :href="slotProps.data.url"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center justify-center p-2 sm:p-4"
          >
            <img
              :src="renderImage(`${slotProps.data.img}`)"
              :alt="slotProps.data.alt"
              class="max-h-24 max-w-full object-contain sm:max-h-28 md:max-h-32"
            />
          </a>
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script setup lang="ts">
import Carousel from 'primevue/carousel';
import renderImage from '~/utils/render-image';

const { t } = useI18n();

const responsiveOptions = [
  {
    breakpoint: '1440px',
    numVisible: 4,
    numScroll: 4,
  },
  {
    breakpoint: '1024px',
    numVisible: 3,
    numScroll: 3,
  },
  {
    breakpoint: '768px',
    numVisible: 2,
    numScroll: 2,
  },
  {
    breakpoint: '640px',
    numVisible: 2,
    numScroll: 2,
  },
  {
    breakpoint: '480px',
    numVisible: 1,
    numScroll: 1,
  },
];

const slides = [
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/united_way.png',
    url: 'https://www.unitedway.org/',
    alt: 'United Way',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/curling_canada.png',
    url: 'https://www.curling.ca/',
    alt: 'Curling Canada',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/fooddepot.png',
    url: 'https://fooddepot.ca/',
    alt: 'Food Depot Alimentaire',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/ns_SPCA.png',
    url: 'https://www.novascotiaspca.ca/',
    alt: 'Nova Scotia SPCA',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/YMCA.png',
    url: 'https://www.ymca.ca/',
    alt: 'YMCA',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/alberta_cancer_foundation.png',
    url: 'https://www.albertacancer.ca/',
    alt: 'Alberta Cancer Foundation',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/rotary.png',
    url: 'https://www.rotary.org/en',
    alt: 'Rotary',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/wallaceburg.png',
    url: 'https://wallaceburghockey.com/',
    alt: 'Wallaceburg',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/christmas_daddies.png',
    url: 'https://www.christmasdaddies.org/',
    alt: 'Christmas Daddies',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/ns_special_olympics.png',
    url: 'https://www.specialolympicsns.ca/',
    alt: 'Nova Scotia Special Olympics',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/calgary_public_libary.png',
    url: 'https://libraryfoundation.ca/',
    alt: 'Calgary Public Library Foundation',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/fort_edmonton.png',
    url: 'https://supportfortedmonton.com/',
    alt: 'Fort Edmonton',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/hope_for_wildlife.png',
    url: 'https://www.hopeforwildlife.net/',
    alt: 'Hope for Wildlife',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/halo.png',
    url: 'https://www.haloairambulance.com/',
    alt: 'HALO Air Ambulance',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/theatre_calgary.png',
    url: 'https://www.theatrecalgary.com/',
    alt: 'Theatre Calgary',
  },
  {
    img: 'RaffleboxLogos/WebsiteAssets/TicketLogos/alberta_ballet.png',
    url: 'https://www.albertaballetschool.com/',
    alt: 'Alberta Ballet School',
  },
];
</script>
